export enum AppPlatform {
  iOS = "ios",
  Android = "android",
  Amazon = "amazon",
  Web = "web",
}

export enum AnalyticsEventType {
  ACTIVE = "ACTIVE",
  BACKGROUND = "BACKGROUND",
  PAGE_VIEW = "PAGE_VIEW",
}

// Kids game device cases (used in project preview)
export enum GameCase {
  GRAY = "gray",
  BLUE = "blue",
  CYAN = "cyan",
  MILK = "milk",
  PINK = "pink",
  GREEN = "green",
  ORANGE = "orange",
  SOFT_PINK = "soft_pink",
  SOFT_YELLOW = "soft_yellow",
}

export enum DeviceNotification {
  NOT_DETERMINED = "NOT_DETERMINED",
  AUTHORIZED = "AUTHORIZED",
  DENIED = "DENIED",
}

export enum LocalStorageKey {
  LAST_SIGN_AT = "last_sign_at",
  ACTIVE_USER_UID = "active_user_uid",
  LAST_ACTIVE_USER_UID = "last_active_user_uid",
  DISMISS_BANNER = "dismiss_banner",
  DISMISS_SURVEY_BANNER = "dismiss_survey_banner",
  KEYBOARD_HEIGHT = "keyboard_height",
}

// Child player config (managed by parents)
export interface UserConfig {
  is_first: boolean;
  locale: string | null;
  sound: { enable: boolean; volume: number };
  bgm: { enable: boolean; volume: number };
  project_publish: boolean;
  project_copied: boolean;
  ai_chat: boolean;
  ai_generation: boolean;
  // ピースビルダー（つくってパズル）の保護者設定
  comment_enabled: boolean;
  piece_publish: boolean;
  piece_copy: boolean;
  shake_bug_report: boolean;
}

export enum EventType {
  BEFORE_INSTALL_PROMPT = "before_install_prompt",
}

export type Asset = {
  id: number;
  uid: string;
  type: string;
  name: string;
  tags: string;
  content_type: string;
  file_size: number;
  metadata: { width: string; height: string; [key: string]: string };
  url: string;
  created_at: string;
};

export enum DialogType {
  LOADING = "loading",
  NOTIFICATION = "notification",
  ERROR_NETWORK = "error_network",
  RESTRICTED_FEATURE = "restricted_feature",
  PARENT_GATE = "parent_gate",
  SHAKE_BUG_REPORT = "shake_bug_report",
}

// Subscription feature restrictions
export enum RestrictedFeatureSource {
  COURSE = "course",
  PROJECT_LIMIT = "project_limit",
  CHILD_USER_LIMIT = "child_user_limit",
  CHILD_USER_ADD_TRIAL = "child_user_add_trial",
  PARENT_SETTINGS = "parent_settings",
  AI_CHAT_LIMIT = "ai_chat_limit",
  AI_IMAGE_LIMIT = "ai_image_limit",
  CHAT_IMAGE = "chat_image",
  ASSET_LIMIT = "asset_limit",
  GUEST_LOGIN_PROMPT = "guest_login_prompt",
}

export interface ConfigState {
  loading: boolean;
  parentConfig: UserConfig;
  userConfig: UserConfig;
  notification: {
    parents: {
      id: number;
      ja_kanji: { date: string; title: string; content: string };
      zh_tw: { date: string; title: string; content: string };
      zh_cn: { date: string; title: string; content: string };
      en: { date: string; title: string; content: string };
      published_at: string;
    }[];
    maintenances: {
      id: number;
      ja: { date: string; title: string; content: string };
      zh_tw: { date: string; title: string; content: string };
      zh_cn: { date: string; title: string; content: string };
      en: { date: string; title: string; content: string };
      created_at: string;
      published_at: string;
    }[];
  };
  banned: { words: { id: number; word: string }[] };
  assets: {
    [prefix: string]: {
      fileKey: string;
      fileSize: number;
      category?: string;
    }[];
  };
  event: {
    before_install_prompt: { value: boolean; args?: { [key: string]: string } };
  };
  dialog: {
    loading: { value: boolean; args?: { [key: string]: string } };
    notification: { value: boolean; args?: { [key: string]: string } };
    error_network: { value: boolean; args?: { [key: string]: string } };
    restricted_feature: { value: boolean; args?: { [key: string]: string } };
    parent_gate: { value: boolean; args?: { [key: string]: string } };
    shake_bug_report: { value: boolean; args?: { [key: string]: string } };
  };
  justAuthenticated: boolean;
}
